import CryptoJS from 'crypto-js/'

const Secure = {
    encrypt: (username: string, secret: string) => {
        var hash = CryptoJS.HmacSHA256(username, secret);
        return CryptoJS.enc.Base64.stringify(hash);
    }
}

export default Secure